import { Button } from "@material-ui/core";
import PriorityKPIGraphIcon from "assets/PriorityKPIGraphIcon.svg";
import projectsIcon from "assets/Projects.svg";
import PyramidIconThemeLevel from "assets/PyramidIconThemeLevel.svg";
import PlanIcon from "assets/StrategicKpi.svg";
import { ITopElement } from "backend/model/model";
import clsx from "clsx";
import { t } from "i18next";
import { getKpisAndProjectsManagementHierarchyMode } from "qpr-base/configuration";
import Anchor from "qpr-base/ui/Anchor";
import React from "react";
import { MappedData } from "./index.dto";
import { useSubStyles } from "./stylesKpiProjectManagement";
import ViewTable from "./viewTable";

const LEVEL_TITLES = ["Strategic", "Perspective", "Priority"];
const KPI_ICONS: Record<string, any> = {
  Plan: PlanIcon,
  Theme: PyramidIconThemeLevel,
  Priority: PriorityKPIGraphIcon,
};
const ManagementTable = ({
  linkHandler,
  elements,
  topElements,
  topElement,
  selectedElement,
  elementDeleted,
  isAdmin,
  configsData,
  selectedLevel,
  selectedLevelIndex,
  isKpi,
  userRole,
}: {
  linkHandler: (type: string) => void;
  elements?: MappedData[];
  topElements: ITopElement[];
  topElement?: any;
  selectedElement: MappedData | undefined;
  elementDeleted: (id: string) => void;
  isAdmin: boolean;
  configsData: {
    create: boolean;
    edit: boolean;
    delete: boolean;
  };
  selectedLevel?: string;
  selectedLevelIndex: number;
  isKpi: boolean;
  userRole: string;
}) => {
  const classes = useSubStyles();
  const hierarchyMode = getKpisAndProjectsManagementHierarchyMode();

  let title;
  if (hierarchyMode === "Perspectives")
    title = (
      isKpi
        ? t(`configtypes.${LEVEL_TITLES[selectedLevelIndex]} KPIs`)
        : t(`configtypes.${LEVEL_TITLES[selectedLevelIndex]} Projects`)
    ).trim();
  else title = isKpi ? t(`configtypes.KPIs`) : t(`configtypes.Projects`);

  const getSelectedElementId = () => {
    if (!selectedElement) {
      if (hierarchyMode === "Scorecards") return topElement?.id || "";
      return "";
    }
    return selectedElement.typename === "Scorecard"
      ? selectedElement.topelementid
      : selectedElement.id;
  };

  const getViewTableHeaders = (): string[] => {
    const headers = [
      isKpi ? t("kpis.KPI Name") : t("initiatives.Project Name"),
    ];
    if (hierarchyMode === "Perspectives")
      headers.push(t("configtypes.Scorecard"));
    return headers;
  };

  return (
    <>
      <Anchor name={isKpi ? "kpis" : "projects"} />
      <div className={classes.container}>
        <div className={classes.titleContainer}>
          <div className={clsx(classes.titles, "DinNextLTArabic")}>
            <img
              src={isKpi ? KPI_ICONS.Plan : projectsIcon}
              className={classes.titleIcon}
              alt="icon"
            />
            <h1>{t(title)}</h1>
          </div>
          <Button
            className={clsx(
              classes.button,
              isAdmin || configsData.create
                ? classes.submitButton
                : classes.disabledSubmitButton
            )}
            disabled={!(isAdmin || configsData.create)}
            onClick={() =>
              linkHandler(
                `${isKpi ? "kpi" : "project"}sform/${getSelectedElementId()}`
              )
            }
          >
            {" "}
            {t(isKpi ? `+ ${t("Add new KPI")}` : `+ ${t("Add new Project")}`)}
          </Button>
        </div>

        <div>
          <ViewTable
            linkeHandler={linkHandler}
            headers={getViewTableHeaders()}
            elements={elements}
            topElements={topElements}
            elementDeleted={elementDeleted}
            configsData={configsData}
            isAdmin={isAdmin}
            isKpi={isKpi}
            metaDatas={elements?.map((e) => e.translations) || []}
            userRole={userRole}
            selectedLevel={selectedLevel || ""}
          />
        </div>
      </div>
    </>
  );
};
export default ManagementTable;
